import type { CompanyRow, CursorPage } from '@dru/types';
import { api } from '../../../lib/api';
import { useQuery } from '../../../lib/useQuery';
import { remembered } from './companyChoice';

/** Resolve a deep link independently of the first registry page. API remains the authority. */
export function useFinanceCompanies(asked: string | null) {
  const selected = asked || remembered();
  return useQuery<CursorPage<CompanyRow>>(async () => {
    const page = await api.get<CursorPage<CompanyRow>>('/tenants?status=ACTIVE&limit=25');
    if (!selected || page.items.some(c => c.id === selected)) return page;
    const company = await api.get<CompanyRow>(`/tenants/${encodeURIComponent(selected)}`);
    return { ...page, items: [company, ...page.items] };
  }, [selected]);
}
